import React, { useEffect, useReducer } from 'react';
import { Button } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import IntegrationSource from '../../../../../../shared/integration-source/IntegrationSource';
import { formDataValidate } from '../../../../../../utils/formUtils';
import { notificationManager } from '../../../../../../utils/NotificationUtils';
import { stepDownLoaderCount, stepUpLoaderCount } from '../../../../../../utils/loaderSlice';
import { ENVIRONMENT } from '../../../../../../env/Configurations';
import { fetchIntegrationStatus } from '../../../../configurationSlice';

const Payment = ({ selectedHotel, showLoader = () => {} }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (selectedHotel) dispatch(fetchIntegrationStatus(selectedHotel));
  }, [selectedHotel, dispatch]);

  const [formData, setFormData] = useReducer((s, n) => ({ ...s, ...n }), {
    integrationSource: { value: '', fieldName: 'Integration Source', errors: {}, validations: [] },
    integrationSourceSelected: { value: '', fieldName: 'Vendor', errors: {}, validations: [] },
  });

  const validate = () => {
    const updated = {};
    const ok = formDataValidate(formData, updated);
    setFormData(updated);
    return ok;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      dispatch(stepUpLoaderCount());
      if (!validate()) return;
      notificationManager('success', 'Payment settings saved');
    } catch (err) {
      if (ENVIRONMENT === 'dev') console.log(err?.message);
      notificationManager('danger', 'Unable to save Payment settings');
    } finally {
      dispatch(stepDownLoaderCount());
    }
  };

  return (
    <form onSubmit={handleSubmit} className='payment' noValidate>
      <div className='mx-4'>
        <IntegrationSource
          formData={formData}
          setFormData={setFormData}
          section='PAYMENTS'
          headTitle='Integration Source'
          showLoader={showLoader}
        />
      </div>
    </form>
  );
};

export default Payment;
